import { render } from "./DrugTestList.vue?vue&type=template&id=8f4b23c8&ts=true"
import script from "./DrugTestList.vue?vue&type=script&lang=ts"
export * from "./DrugTestList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__